import dynamic from 'next/dynamic'

export const CONTACTUS_COMPONENTS_MAPPING = {
  'contact-us.contact-channel': dynamic(() => import('@components/ContactUsV2/ContactChannelBase')),
  'contact-us.bot-channel': dynamic(() => import('@components/ContactUsV2/BotChannel/BotChannel')),
  'contact-us.quick-actions-section': dynamic(
    () => import('@components/ContactUsV2/QuickActions/QuickActionsContainer')
  ),
  'contact-us-internal.rating-section': dynamic(() => import('@components/Home/Rating')),
  'contact-us.complaint-channel': dynamic(() => import('@components/ContactUsV2/ComplaintSection')),
  'contact-us-internal.callback-section': dynamic(() => import('@components/ContactUsV2/CallbackSection')),
}

export const CONTACT_US_EVENTS = {
  // Page View Events
  PAGE_VIEWED: {
    eventName: 'page_viewed',
    eventProps: {
      journey: 'contact_us',
    },
  },

  // Tap Button Interaction Events
  CALL_HELPLINE_CLICKED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_callus',
    },
  },
  EMAIL_US_CLICKED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_email',
    },
  },
  GRIEVANCE_CLICKED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_grievance',
    },
  },
  REQUEST_CALLBACK_CLICKED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_request_callback',
    },
  },
  CHAT_NOW_SALES_CLICKED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_chat_now',
      type: 'sales',
    },
  },
  CHAT_NOW_SUPPORT_CLICKED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_chat_now',
      type: 'support',
    },
  },
  PREFILL_QUESTIONS_CLICKED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_prefill_questions',
    },
  },
  QUICK_ACTIONS_CLICKED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us',
    },
  },
  CALL_LIST_CLICKED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_call_list',
    },
  },
  EMAIL_LIST_CLICKED: {
    eventName: 'tap_btn_interaction',
    eventProps: {
      journey: 'contact_us_email_list',
    },
  },
}

export const eventConfig = {
  Phone: {
    eventName: CONTACT_US_EVENTS.CALL_HELPLINE_CLICKED.eventName,
    eventProps: CONTACT_US_EVENTS.CALL_HELPLINE_CLICKED.eventProps,
  },
  Email: {
    eventName: CONTACT_US_EVENTS.EMAIL_US_CLICKED.eventName,
    eventProps: CONTACT_US_EVENTS.EMAIL_US_CLICKED.eventProps,
  },
}
